import { DaoModel } from '@dynameat/models';
import { AssociatedProduct } from './associatedProduct';

export class ProductIndexing extends DaoModel {
  constructor(referenceProductGuid, associatedProducts) {
    super(referenceProductGuid);
    this.referenceProductGuid = referenceProductGuid;
    this.associatedProducts = associatedProducts || [];
  }

  static toInstance(props = {}) {
    return new ProductIndexing(
      props.reference_product_guid,
      AssociatedProduct.toInstanceList(props.associated_products)
    );
  }

  addAssociatedProduct(productIndexingGuid, associatedProductGuid, ratio) {
    this.associatedProducts.push(new AssociatedProduct(productIndexingGuid, associatedProductGuid, ratio));
  }

  removeAssociatedProduct(productIndexingGuid) {
    const index = this.associatedProducts.findIndex((associated) => associated.productIndexingGuid === productIndexingGuid);
    this.associatedProducts.splice(index, 1);
  }

  editRatio(associatedProductGuid, ratio) {
    const associatedProduct = this.associatedProducts.find((associated) => associated.associatedProductGuid === associatedProductGuid);
    associatedProduct.ratio = ratio;
  }

  static deSerializeInternalModel(props) {
    return {
      guid: props.guid,
      ratio: props.ratio,
      referenceProductGuid: props.reference_product,
      associatedProductGuid: props.associated_product
    };
  }

  serialize(productIndexingGuid) {
    let associatedProduct;
    if (productIndexingGuid) {
      associatedProduct = this.associatedProducts.find((associated) => associated.productIndexingGuid === productIndexingGuid);
    } else {
      // eslint-disable-next-line prefer-destructuring
      associatedProduct = this.associatedProducts[0];
    }
    return {
      guid: associatedProduct.productIndexingGuid,
      reference_product: this.referenceProductGuid,
      associated_product: associatedProduct.associatedProductGuid,
      ratio: associatedProduct.ratio
    };
  }
}
